import * as React from 'react';

// UTILS
import { listenForOutsideClicks } from '../utils';

// ICONS
import { ReactComponent as ChevronDown } from '../assets/svg/chevron-down.svg';

// TYPES
interface MultiSelectTypes {
	name?: string;
	placeholder?: string;
	options?: { label?: string; value?: string }[];
	values: string[];
	onChange?: any;
	isDisabled?: boolean;
}

export const MultiSelect: React.FC<MultiSelectTypes> = ({
	name = '',
	placeholder = ' ',
	options,
	values,
	isDisabled = false,
	onChange
}) => {
	const [selectedValues, setSelectedValues] = React.useState<MultiSelectTypes['values']>([]);

	const [isOpen, setIsOpen] = React.useState<boolean>(false);
	const elementRef = React.useRef(null);

	listenForOutsideClicks(elementRef, isOpen, setIsOpen);

	const toggleOpen = (open?: boolean) => {
		if (open !== undefined) {
			setIsOpen(open);
		} else {
			setIsOpen(!isOpen);
		}
	};

	const handleChange = (value: string | undefined) => {
		if (value !== undefined) {
			const selectedValue = value.toString().toLowerCase();
			const selectedValueIndex = selectedValues.indexOf(selectedValue);
			const newValues = selectedValues.slice();

			if (selectedValueIndex !== -1) {
				newValues.splice(selectedValueIndex, 1);
			} else {
				newValues.push(selectedValue);
			}

			setSelectedValues(newValues);

			if (onChange) {
				onChange(newValues);
			}
		}
	};

	React.useEffect(() => {
		if (values && values.length) {
			setSelectedValues(values);
		}
	}, [values]);

	return (
		<div className={`multi-select ${isOpen ? 'open' : ''} ${isDisabled ? 'disabled' : ''}`} ref={elementRef}>
			<div
				className={`multi-select-display form-control ${isOpen ? 'active' : ''}`}
				onClick={() => toggleOpen()}
				tabIndex={1}
			>
				{!selectedValues || !selectedValues.length ? (
					<span className="placeholder">{placeholder}</span>
				) : (
					options &&
					options.length > 0 &&
					options
						.filter((option) => selectedValues.includes(option.value?.toLowerCase() || ''))
						.map((option, index, options) => (
							<React.Fragment key={'selected-' + index}>
								<span>{option.label}</span>
								{index !== options.length - 1 && ','}
							</React.Fragment>
						))
				)}
				<ChevronDown />
			</div>

			{options && options.length > 0 && isOpen ? (
				<div className="multi-select-options">
					<ul>
						{options.map((option, index) => (
							<li key={'option-' + option.value}>
								<label className="form-control-checkbox">
									<input
										type="checkbox"
										value={option.value}
										checked={selectedValues.includes(option.value?.toLowerCase() || '')}
										onChange={() => {
											handleChange(option.value);
										}}
									/>
									<span>{option.label}</span>
								</label>
							</li>
						))}
					</ul>
				</div>
			) : null}
		</div>
	);
};

export default MultiSelect;
